export default __webpack_public_path__ + "static/sfchronicle-eb6be123ac3f7a90916413d2c7824aa9.svg";